import autoruTheme from './autoru';

export const themes = {
  autoru: autoruTheme,
};

const DEFAULT_THEME = themes.autoru;

export default DEFAULT_THEME;
